// 活动
export default [
  {
    path: '/activity/dumpling-statistics',
    component: resolve => require(['@/pages/activity/dumpling-statistics.vue'], resolve),
    name: 'dumpling-statistics',
    meta: {
      title: '饺子券统计'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/activity.js